<template>
  <div class="container bounceInUp">
    <div v-if="this.producto != {} && this.ready" class="blog-post">

      <!-- Header con boton volver -->
      <div class="header d-flex justify-content-between align-items-center">
        <div>
          <router-link to="/productos" class="btn btn-light volver d-flex align-items-center ">
            <i class="fa-solid fa-arrow-left me-2"></i>
            Volver
          </router-link>
        </div>
        <div class="estado-producto text-center">
          <!-- Estado de producto -->
          <div v-if="this.producto.stock > 0" class="disponible mt-3 diponibilidad-producto">
            <p>Disponible</p>
          </div>
          <div v-else-if="this.producto.stock == 0 && producto.coming_soon == true"
            class="reserva diponibilidad-producto">
            <p>¡Llega pronto!</p>
            <p>Reserva tu producto</p>
          </div>
          <div v-else-if="this.producto.stock == 0" class="vendido diponibilidad-producto">
            <p>Vendido</p>
          </div>
        </div>

      </div>
      <hr style="color: #b7b7b7;">

      <div class="row ">
        <div class="col-12 col-lg-4 d-flex ">
          <div class="d-flex flex-column">

          <div class="post-images">
            <img :src="this.imgSelect" class="image" alt="Imagen del producto" />
          </div>

          <div class="d-flex justify-content-center align-items-center flex-wrap">
            <div v-for="(img, index) in producto.images" :key="index" class="thumbnail">
              <img :src="img.image" @click="selectedImage(img.image)" class="image" alt="Imagen del producto" />
            </div>
          </div>
          </div>
          <div class="ms-1 me-1 linea-vertical "></div>
        </div>
       
        <!-- Contenido de los detalles de producto -->

        <div class="col-12 col-lg-5 ps-2 ps-lg-5 pe-lg-5 pe-2 pt-4 contenido-producto">
          <!-- Titulo del Producto -->
          <h2 class="title ">
            {{ this.producto.name }}
          </h2>
          <!-- Decripcion del Producto -->
          <!-- <p>{{ this.producto.description }}</p> -->

          <div class="ql-editor" v-html="this.producto.description"></div>




          
          <div class="text-center">



          </div>

        </div>
        <div class="col-12 col-lg-3">

          <div class="detalles-pago">
              <!-- Precio y descuento -->
              <!-- <p class="">Detalles de pago</p> -->
          <p v-if="producto.discount" class="precio">{{ this.formatoNumero(this.producto.price - this.producto.price *
            (this.producto.discount / 100)) }} {{ this.moneda }}</p>
          <p v-else class="precio">{{ this.formatoNumero(this.producto.price) }} lps</p>
          <p v-if="producto.discount > 0" class="precio-anterior">{{ this.formatoNumero(this.producto.price) }}
            {{ this.moneda }}</p>


          <!--Etiqueta de Descuento -->
          <div v-if="producto.discount > 0" class="descuento d-flex">

            <i class="fa-solid fa-tag"></i>
            <div class="descuento-texto">&nbsp;&nbsp;{{ Math.round(this.producto.discount) }}% de descuento</div>
          </div>
            <a ref="whatsappLink" target="_blank"></a>
          <button @click="compra()" class="btn btn-dark w-75 mt-4">
            Comprar Ahora
          </button>

          </div>
          
          <!-- Vistas -->
          <div class="d-flex justify-content-end me-4" style="font-size: 13px;">
            <div class="vistas-icono">
              <i class="fa-solid fa-eye"></i>
            </div>
            <div class="vistas-texto">&nbsp;{{ this.producto.views }} vistas</div>
          </div>

        </div>
      </div>


    </div>
    <div v-else class="blog-post">
      <div class="alert alert-primary d-flex align-items-center" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
          class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img"
          aria-label="Warning:">
          <path
            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </svg>
        <div>
          El Producto No Existe
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import Quill from 'quill'
import 'quill/dist/quill.snow.css'

export default {
  name: "BlogPost",
  data() {
    return {
      idProduct: 0,
      articulo: {},
      ready: false,
      moneda: "lps",
      producto: {},
      imgSelect: "",
    }
  },
  beforeMount() {
    this.idProduct = this.$route.params.id

    // this.articulo = articuloData[this.idProduct - 1]

    console.log(this.articulo);

    window.scroll({ top: 0 })


    this.getProduct(this.idProduct)
  },
  mounted() {
    if (this.articulo !== undefined) {
      let contenido = document.getElementById("contenido");
      if (contenido) {
        contenido.innerHTML += this.articulo.contenido;
      }
    }


  },
  methods: {
    selectedImage(img) {
      console.log(this.producto.images);
      console.log(img);
      this.imgSelect = img

    },
    getProduct(id) {

      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };

      fetch(`${process.env.VUE_APP_API_URL}/api/product/products/${id}/`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json(); // Cambiar a JSON si esperas JSON
        })
        .then((data) => {
          console.log("Producto:", data);
          this.producto = data; // Asignar los datos a la variable productos
          this.imgSelect = this.producto.image
          this.producto.images.push({ "image": this.producto.image })


          this.ready = true;
        })
        .catch((error) => console.error("Error al obtener productos:", error));

    },
    formatoNumero(numero) {
      return new Intl.NumberFormat("en-US").format(numero)
    },
    compra(){
            if (this.producto.stock > 0) {
             
            // Número en formato internacional (ejemplo Honduras +504)
            const numero = "50494565133";

            // Mensaje a enviar
            const mensaje = `Hola, quisiera comprar el producto ${this.producto.name} - ${this.producto.id}`;

            // Codificar el mensaje para URL
            const mensajeCodificado = encodeURIComponent(mensaje);

            // Construir enlace de WhatsApp
            const url = `https://wa.me/${numero}?text=${mensajeCodificado}`;

            // Abrir en nueva pestaña
            this.$refs.whatsappLink.href = url;
            this.$refs.whatsappLink.click();

      } else {
        alert("El producto no está disponible para la compra.");
      }
    }
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
  margin: 0 auto;
  padding: 20px;
}

.blog-post {
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.post-images {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
}

.image {
  max-width: 56%;
  border-radius: 8px;
}

.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInUp {

  0%,
  60%,
  75%,
  90%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInUp {

  0%,
  60%,
  75%,
  90%,
  100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.volver {
  color: #383838;
}

.linea-vertical {
  width: 0.5px;
  height: 100%;
  margin-inline: 10px;
  background-color: #e4e4e4;
  margin: 0 10px;
}

.descuento {
  width: 200px;
  position: static;
}

.diponibilidad-producto {
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
}

.disponible {
  background-color: #dcfce7;
  color: #166534;
  display: flex;
  justify-content: center;
}

.estado-producto {
  width: 300px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 5px;
}

.reserva {
  background-color: #fef9c3;
  color: #92400e;
}

.vendido {
  background-color: #f3f4f6;
  color: #6b7280;
}

.precio {
  font-size: 20px;
  font-weight: 600;
  color: #10b981;
  margin-top: 10px;
}

.precio-anterior {
  font-size: 16px;
  text-decoration: line-through;
  color: #9ca3af;
  margin-bottom: 10px;
}

.descuento {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 8px 16px;
  border-radius: 12px;
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
}

.contenido-producto {
  /* margin-top: 25px; */
  margin-bottom: 35px;
}

.thumbnail {
  margin-bottom: 10px;
  width: 80px;
}

.thumbnail img {
  cursor: pointer;

  margin-bottom: 10px;
  width: 80px;
}

.ql-editor {
    width: 100%;           /* Ocupa todo el ancho disponible */
  max-width: 1200px;     /* Límite máximo para pantallas grandes */
  height: auto;          /* Altura se ajusta al contenido */
  padding: 0rem;         /* Margen interno adaptable */
  margin: 0 auto;        /* Centrado horizontal */
  
  box-sizing: border-box; /* Incluye padding y border en el tamaño */
  font-size: 14px;       /* Tamaño de fuente legible */

  /* Opcional: manejo de contenido */
  overflow-wrap: break-word;   /* Rompe palabras largas */
  word-break: break-word;      /* Evita desbordes de texto */
  overflow: hidden;            /* Evita desbordes visuales */

  /* Opcional: diseño flexible */
  display: flex;       
  flex-direction: column; 
  flex-wrap: wrap;     
}

@media (max-width: 768px) {
  .container {
    padding: 0; /* En pantallas pequeñas (celulares) */
  }

  
}


.detalles-pago{
    /* width: 100%; */
    display: flex;
    justify-content: center;
    align-items: center ;
    flex-direction: column;
    border: 1px solid #e4e4e4;
    padding: 10px;
    border-radius: 4px;
    margin: 20px;
    padding-block: 40px;
    /* background-color: #ffffff; */
    
  }

</style>
